<template>
  <div
    :class="[
      'db-tw-mb-6',
      {
        'db-has-error': v$.field.$error,
      },
    ]"
  >
    <div class="db-checkbox-item">
      <DbCheckbox
        :modelValue="modelValue"
        :inputAttrs="{
          value: name,
          name: name,
        }"
        v-on:update:model-value="$emit('update:modelValue', $event)"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="name" />
        <!-- TODO: put required asterix in DbCheckbox ? -->
        <span
          v-if="isMandatory"
          class="db-input-required-indicator"
        >
          *
        </span>
      </DbCheckbox>
      <!-- TODO: temporary while waiting for DbCheckbox to have a slot for errors -->
      <div class="db-tw-text-error-message db-tw-mt-2">
        <DbRfpErrors
          v-if="v$.field.$error"
          :errors="v$.field.$errors"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { validCheckbox } from '@/utils/i18n-validators'

const props = withDefaults(
  defineProps<{
    /** If the checkbox is checked or not */
    modelValue?: boolean
    /* Label of the checkbox */
    name: string
    /* If the checkbox is mandatory */
    isMandatory: boolean
  }>(),
  {
    modelValue: false,
  },
)

defineEmits<{
  (e: 'update:modelValue', modelValue: boolean): void
}>()

const state = computed(() => {
  return {
    field: props.modelValue,
  }
})

const rules = computed(() => {
  return {
    field: { validCheckbox: props.isMandatory ? validCheckbox : true },
  }
})

const v$ = useVuelidate(rules, state, { $autoDirty: true })
</script>

<style scoped>
/*
  Necessary to handle the HTML labels.
  We use v-html with content coming from a WYSIWYG string,
  so it is often wrapped in a p tag
*/
.db-app .db-checkbox-item::v-deep(.db-label span p) {
  display: inline;
}

/*
  Necessary to handle the HTML labels.
  We use v-html with content coming from a WYSIWYG string,
  so it is often wrapped in a p tag
  Inside src/assets/styles/_fonts.css
  we have style that overrides the <p> color
  so we have to override it here
*/
.db-has-error .db-checkbox-item::v-deep(.db-label span p) {
  color: var(--db-color-text-input-field-label-error);
}
</style>
